import { useContext } from 'react';
import { CatalogContext } from './CatalogContext';
import type { Catalog } from './types';

/**
 * Returns only the catalog record. Used by 99% of consumers (StatisticsPage,
 * dotaAssets, etc.) that just need O(1) lookup by name.
 */
export function useCatalog(): Catalog {
  return useContext(CatalogContext).catalog;
}

/**
 * Returns the full context shape including loading / error / refetch.
 * Intended for the admin catalog management page (phase 8).
 */
export function useCatalogState() {
  return useContext(CatalogContext);
}
